import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=220a8071&scoped=true"
import script from "./Page1.vue?vue&type=script&lang=js"
export * from "./Page1.vue?vue&type=script&lang=js"
import style0 from "./Page1.vue?vue&type=style&index=0&id=220a8071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a8071",
  null
  
)

export default component.exports